export default "__VITE_ASSET__y6SwPABW__"